import actions from './actions';

export interface ClientMessagesState {
  messages: any[];
  allMessages: any[];
  isSending: boolean;
  isLoading: boolean;
  error: string | null;
}

const initState: ClientMessagesState = {
  messages: [],
  allMessages: [],
  isSending: false,
  isLoading: false,
  error: null,
};

export default function reducer(
  state: ClientMessagesState = initState,
  { type, payload }: { type: string; payload?: any }
): ClientMessagesState {
  switch (type) {
    case actions.SEND_CLIENT_MESSAGE:
      return {
        ...state,
        isSending: true,
        error: null,
      };
    case actions.SEND_CLIENT_MESSAGE_SUCCESS:
      return {
        ...state,
        isSending: false,
      };
    case actions.SEND_CLIENT_MESSAGE_ERROR:
      return {
        ...state,
        isSending: false,
        error: payload.error,
      };
    case actions.LOAD_CLIENT_MESSAGES:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case actions.LOAD_CLIENT_MESSAGES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        messages: payload.messages,
      };
    case actions.LOAD_CLIENT_MESSAGES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    case actions.LOAD_ALL_CLIENT_MESSAGES_SUCCESS:
      return {
        ...state,
        allMessages: payload.messages,
      };
    case actions.SEND_CLIENT_REPLY:
      return {
        ...state,
        isSending: true,
        error: null,
      };
    case actions.SEND_CLIENT_REPLY_SUCCESS:
      return {
        ...state,
        isSending: false,
      };
    case actions.SEND_CLIENT_REPLY_ERROR:
      return {
        ...state,
        isSending: false,
        error: payload.error,
      };
    default:
      return state;
  }
}
